import EntertainmentDynamicFilterSliders from "./EntertainmentDynamicFilterSliders";
import Favorite from '../../../../assets/images/Favorite-bg6.png'

export default function EntertainmentFilterDataSlider({ checkedFilters,
    sliderData,
    isLoading,
    onLoadMore }) {
    return (
        <>
            <section className="sub_banner_box favorite-section uk-scrollspy-inview"
                style={{ backgroundImage: `url(${Favorite})` }}
                uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true">
                <div className="container d-flex justify-content-center text-center">
                    <div className="favorite-block sub_banner_text_box uk-scrollspy-inview"
                        uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true">
                        <h2 className="mb-2">Caribbean Cruise Sale</h2>
                        <p>Save up to 75% on Caribbean cruise Today. Best price guarantee.</p>
                    </div>
                </div>
            </section>

            <EntertainmentDynamicFilterSliders checkedFilters={checkedFilters}
                sliderData={sliderData}
                isLoading={isLoading}
                onLoadMore={onLoadMore} />

        </>
    )
}
